export enum BackgroundAudioType {
  NONE = 'none',
  CALL_CENTER = 'call_center',
  BUSY_OFFICE = 'busy_office',
  COFFEE_SHOP = 'coffee_shop',
  CONVENTION_HALL = 'convention_hall',
  COUNTRYSIDE = 'countryside',
  NATURE_MORNING = 'nature_morning',
  SWIMMING_POOL = 'swimming_pool',
  WHITE_NOISE = 'white_noise',
}

export const BACKGROUND_AUDIO_OPTIONS = [
  { value: BackgroundAudioType.NONE, label: 'None' },
  { value: BackgroundAudioType.CALL_CENTER, label: 'Call center' },
  { value: BackgroundAudioType.BUSY_OFFICE, label: 'Busy office' },
  { value: BackgroundAudioType.COFFEE_SHOP, label: 'Coffee shop' },
  { value: BackgroundAudioType.CONVENTION_HALL, label: 'Convention hall' },
  { value: BackgroundAudioType.COUNTRYSIDE, label: 'Countryside' },
  { value: BackgroundAudioType.NATURE_MORNING, label: 'Nature morning' },
  { value: BackgroundAudioType.SWIMMING_POOL, label: 'Swimming pool' },
  { value: BackgroundAudioType.WHITE_NOISE, label: 'White noise' },
] as const
